module.exports = __webpack_public_path__ + "static/Back-end Development-ae8efaec71ada8fcc5ae4b6c0f3a5c71.png";